import { stat } from 'fs';
import { Api, ApiCrib } from '../api';
import { IResponseCrib, IUpdateCrib, IDetalheCampanha, IListagemCribLog, ICampanhas, IRespListagemCrib, IComunicacaoGrupoControle } from 'shared/types';
import { useSelectedOrganization } from 'shared/store/organization';




const ExecBD = async (idCampanha: number, iduser: number, org: number, AMB: string, idexec: string, flag: string): Promise<IResponseCrib[] | Error> => {
  try {


    const { data, status } = await ApiCrib.post(`/Crib/${idCampanha}/${iduser}/${org}/${AMB}/${idexec}/${flag}`);

    if (data) {

      return data;

    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getLog = async (idOrg: number,idCampanha: number, IDexec: string): Promise<IRespListagemCrib | Error> => {
  try {


    const { data } = await ApiCrib.get(`/Crib/CribCampanha/${idOrg}/${idCampanha}/${IDexec}`);

    if (data) {

      return data;

    }



    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAll = async (org: number, ): Promise<ICampanhas[] | Error> => {
  try {


    const { data } = await ApiCrib.get(`/Crib/CribCampanha/${org}`);

    if (data) {
      
      return data;

    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async ( org:number,id: string): Promise<IDetalheCampanha | Error> => {
  try {
    const { data } = await ApiCrib.get(`/Crib/CribCampanha/${Number(org)}/Campanha/${Number(id)}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const GetTest = async (exec_id: number, cmp_id: number, org_cd: number): Promise<IListagemCribLog[] | Error> => {
  try {

    const sessionData = localStorage.getItem("recoil-persist");
    if (!sessionData) {
      throw new Error("Dados de sessão não encontrados.");
    }
    const parsedData = JSON.parse(sessionData);
    const token = parsedData.sessionUser?.token;

    const body = {
      exec_id: exec_id,
      cmp_id: cmp_id,
      org_cd: org_cd
    };

    const { data } = await ApiCrib.post('/Crib/SendTest', body,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (data) {

      return data;

    }



    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const update = async (idCampanha: number,idorg: number, dados: IUpdateCrib): Promise<void | Error> => {
  try {
    const { data, status } = await ApiCrib.put(`/Crib/${idCampanha}/${idorg}`, dados);
    const { erro } = data.erro;    
    if (data.erro) {
      return new Error(`${data.erro}`);
    }

    if (data.Error) {
      return new Error(`${data.Error}`);
    }
    if (status > 299) {
      const chaves = Object.keys(data.erro); 

      return new Error(data.erro[chaves[0]][0]);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};


const SaveQuery = async (exec_id: number, cmp_id: number): Promise<IListagemCribLog[] | Error> => {
  try {

    const sessionData = localStorage.getItem("recoil-persist");
    if (!sessionData) {
      throw new Error("Dados de sessão não encontrados.");
    }
    const parsedData = JSON.parse(sessionData);
    const token = parsedData.sessionUser?.token;

    const body = {
      exec_id: exec_id,
      cmp_id: cmp_id
    };

    const { data } = await ApiCrib.patch('/Crib/SaveQuery', body,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (data) {

      return data;

    }



    return new Error('Erro ao salvar query.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao salvar query.');
  }
};


export const CribService = {
  ExecBD,
  update,
  getLog,
  GetTest,
  getAll,
  getById,
  SaveQuery
  // getComById

};
